<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-2" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Turnover-Report') }} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> {{ $t('Send-Mail') }}
</v-btn>

              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

<!-- MAIL GÖNDER DIALOG -->
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>{{ $t('Send-Mail') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              :label="$t('Recipient-Email')"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              :label="$t('Agency-Name')"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              :label="$t('Document-Type')"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              :label="$t('Agent-Full-Name')"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              :label="$t('Message')"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">{{ $t('Cancel') }}</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>{{ $t('Send') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                      </v-flex>



                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout fill-height="" align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 v-if="Rapor.Tip=='0'" md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title> <span class="subheading info--text">
                                  {{ $t('Grand-Total') }}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>

                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{$t('Gross')}} :
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">
                                                    {{toplamGen.GelirBrut | moneyformat }}{{getparabirimi()}}
                                                  </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>



                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                 {{ this.$t('Discount') }} :
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{toplamGen.GelirIskonto | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>

                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>


                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{ $t('Net') }} :
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{toplamGen.GelirNet | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>

                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>

                                </v-card>
                              </v-flex>


                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{ $t('VAT') }} :
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{toplamGen.GelirKdv | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>


                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>

                            </v-layout>


                          </v-flex>

                          <v-flex xs12 sm6 md3>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                            <v-card flat class="black--text">
                              <v-layout>
                                <v-flex xs2 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="grey">bar_chart</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm11 md11>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout>
                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <span class="subheading black--text font-weight-">
                                              {{$t('Total')}} :
                                            </span>
                                          </v-list-tile-title>
                                        </v-flex>

                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">
                                              <span class="subheading black--text font-weight-">
                                                {{toplamGen.GelirToplam | moneyformat }}{{getparabirimi()}}
                                              </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>

                                      </v-layout>
                                    </v-flex>
                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                            <v-card flat class="black--text">
                              <v-layout>
                                <v-flex xs2 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="grey">bar_chart</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm11 md11>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout row wrap>
                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <span class="subheading black--text font-weight-">
                                              {{ $t('Currency-Total') }} :
                                            </span>
                                          </v-list-tile-title>
                                        </v-flex>

                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">
                                              <span class="subheading black--text font-weight-">

                                                {{toplamGen.GelirDovizToplam | moneyformat }}{{getparabirimi()}} </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>


                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                <v-flex v-if="Rapor.Tip=='2' || Rapor.Tip=='0'" xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title> <span class="subheading font-weight-bold green--text"> {{ $t('Income') }}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md3>
                                <v-text-field flat="" box hide-details v-model="searchsatilanbilet" :label="$t('Search')"
                                  append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{$t('Gross')}} :

                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{gelirGen.GelirBrut | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>

                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>



                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{ $t('Discount') }} :

                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{gelirGen.GelirIskonto | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>

                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>


                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{ $t('Net') }} :

                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{gelirGen.GelirNet | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>

                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>

                                </v-card>
                              </v-flex>


                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{ $t('VAT') }} :
                                                </span>
                                              </v-list-tile-title>

                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{gelirGen.GelirKdv | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>


                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>

                            </v-layout>


                          </v-flex>

                          <v-flex xs12 sm6 md3>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                            <v-card flat class="black--text">
                              <v-layout>
                                <v-flex xs2 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="grey">bar_chart</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm11 md11>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout>
                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <span class="subheading black--text font-weight-">
                                              {{$t('Total')}} :
                                            </span>
                                          </v-list-tile-title>
                                        </v-flex>
                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">
                                              <span class="subheading black--text font-weight-">

                                                {{gelirGen.GelirToplam | moneyformat }}{{getparabirimi()}} </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>

                                      </v-layout>
                                    </v-flex>
                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                            <v-card flat class="black--text">
                              <v-layout>
                                <v-flex xs2 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="grey">bar_chart</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm11 md11>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout row wrap>

                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <span class="subheading black--text font-weight-">
                                              {{ $t('Currency-Total') }} :
                                            </span>
                                          </v-list-tile-title>
                                        </v-flex>
                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">
                                              <span class="subheading black--text font-weight-">

                                                {{gelirGen.GelirDovizToplam | moneyformat }}{{getparabirimi()}} </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>





                                      </v-layout>
                                    </v-flex>
                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-start="" justify-start="" fill-height="">
                              <span class="subheading grey--text font-weight-">
                                {{ $t('Income-Details') }}
                              </span>
                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>


                          <v-flex xs12 sm12>
                            <v-card flat>
                              <div class="ciro-report-table">
                              <ReportTable
                                :headers="headerssatis"
                                :items="itemssatis"
                                storage-key="ciroraporu_gelir_columns"
                                :loading="progress"
                                :has-searched="itemssatis && itemssatis.length > 0"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Income-Details')"
                                :export-meta-items="ciroExportMetaItems"
                                :export-summary-cards="ciroGelirSummaryCards"
                                :rows-per-page-items="[20, 50, 100, 250, 500, 1000]"
                              ></ReportTable>
                            </div>
                            </v-card>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex v-if="Rapor.Tip=='1' || Rapor.Tip=='0'" xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title> <span class="subheading font-weight-bold red--text">
                                  {{ $t('Expense') }}
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs3 sm3 md3>
                                <v-text-field flat="" box="" color="info" hide-details v-model="searchiadebilet"
                                  :label="$t('Search')" append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{$t('Gross')}} :
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{giderGen.GelirBrut | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>


                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>



                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{ $t('Discount') }} :
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{giderGen.GelirIskonto | moneyformat }}{{getparabirimi()}}</span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>


                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>


                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{ $t('Net') }} :

                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">

                                                    {{giderGen.GelirNet | moneyformat }}{{getparabirimi()}} </span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>


                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>

                                </v-card>
                              </v-flex>


                              <v-flex xs12 sm6 md3>
                                <v-card flat class="black--text">
                                  <v-divider light></v-divider>
                                  <v-layout>
                                    <v-flex xs2 sm1 md1>
                                      <v-layout align-center="" justify-center="" fill-height="">
                                        <v-icon color="grey">bar_chart</v-icon>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm11 md11>
                                      <v-card-title primary-title="">
                                        <v-flex xs12 sm12 md12>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <span class="subheading black--text font-weight-">
                                                  {{ $t('VAT') }} :
                                                </span>
                                              </v-list-tile-title>
                                            </v-flex>

                                            <v-flex xs6 sm6 md6>
                                              <v-list-tile-title>
                                                <v-layout justify-end="">
                                                  <span class="subheading black--text font-weight-">
                                                    {{giderGen.GelirKdv | moneyformat }}{{getparabirimi()}}</span>
                                                </v-layout>
                                              </v-list-tile-title>
                                            </v-flex>



                                          </v-layout>
                                        </v-flex>
                                      </v-card-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-card>
                              </v-flex>

                            </v-layout>


                          </v-flex>

                          <v-flex xs12 sm6 md3>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                            <v-card flat class="black--text">
                              <v-layout>
                                <v-flex xs2 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="grey">bar_chart</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm11 md11>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout>
                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <span class="subheading black--text font-weight-">
                                              {{$t('Total')}} :
                                            </span>
                                          </v-list-tile-title>
                                        </v-flex>

                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">
                                              <span class="subheading black--text font-weight-">

                                                {{giderGen.GelirToplam | moneyformat }}{{getparabirimi()}} </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>


                                      </v-layout>
                                    </v-flex>
                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm6 md3>
                            <v-card flat class="black--text">
                              <v-layout>
                                <v-flex xs2 sm1 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="grey">bar_chart</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm11 md11>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout row wrap>
                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <span class="subheading black--text font-weight-">
                                              {{$t('Currency-Total')}} :
                                            </span>
                                          </v-list-tile-title>
                                        </v-flex>

                                        <v-flex xs6 sm6 md6>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">
                                              <span class="subheading black--text font-weight-">

                                                {{giderGen.GelirDovizToplam | moneyformat }}{{getparabirimi()}} </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>

                                      </v-layout>
                                    </v-flex>
                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-start="" justify-start="" fill-height="">
                              <span class="subheading grey--text font-weight-">
                                {{ $t('Expense-Details') }}
                              </span>
                            </v-layout>
                            <v-divider light></v-divider>
                          </v-flex>


                          <v-flex xs12 sm12>
                            <v-card flat>
                              <div class="ciro-report-table">
                              <ReportTable
                                :headers="headerssatis"
                                :items="itemsiade"
                                storage-key="ciroraporu_gider_columns"
                                :loading="progress"
                                :has-searched="itemsiade && itemsiade.length > 0"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Expense-Details')"
                                :export-meta-items="ciroExportMetaItems"
                                :export-summary-cards="ciroGiderSummaryCards"
                                :rows-per-page-items="[20, 50, 100, 250, 500, 1000]"
                              ></ReportTable>
                            </div>
                            </v-card>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>





              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <v-flex xs12 sm12 md12>
                            <cariaracomp v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="Rapor.Cari.Kod" v-model="Rapor.Cari.Kod" ></cariaracomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <!-- <v-select :items="referansitems" hide-details v-model="Rapor.Referanslar"
                                :label="$t('Reference')" multiple item-text="Title" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Kod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                  Rapor.Referanslar - 1 }} {{ $t('other-record') }})</span>
                                </template>
                              </v-select> -->
                              <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="ReferansPrm.Kod" >
                              </referansmerkezicomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-select :items="evraktipi" hide-details="" v-model="Rapor.Evraklar" :label="$t('Document-Type')"
                                multiple item-text="Title" item-value="Evrakkod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Evrakkod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                  Rapor.Evraklar.length - 1 }} {{ $t('other-record') }})</span>
                                </template>
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-radio-group row v-model="Rapor.Tip">
                                <v-radio value="0" :label="$t('All-v2')"></v-radio>
                                <v-radio value="1" :label="$t('Buying')"></v-radio>
                                <v-radio value="2" :label="$t('Sales')"></v-radio>
                              </v-radio-group>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import ReportTable from "@/components/app/customcomp/ReportTable.vue"


  export default {
    data() {
      return {
        mailDialog: false,
mailValid: false,
mailLoading: false,
mailPayload: {
  To: "",
  AgencyName: "",
  DocType: "",
  AgentFullName: "",
  CustomBody: ""
},
rules: {
  required: v => !!v || this.$t('Required-Field'),
  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || this.$t('Enter-Valid-Email')
},

        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        referansitems: [],
        evraktipi: [],
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        ReferansPrm: {
                Kod: ''},
        headerssatis: [{
            text: this.$t('Document-Type'),
            value: 'Evraktipi',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '200px'
          },
          {
            text: this.$t('Number'),
            value: 'Adet',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'right',
            width: '120px'
          },
          {
            text: this.$t('Gross'),
            value: 'Brut',
            align: 'right',
            visible: true,
            sortable: true,
            type: 'money',
            width: '150px'
          },
          {
            text: this.$t('Discount'),
            value: 'Iskonto',
            align: 'right',
            visible: true,
            sortable: true,
            type: 'money',
            width: '150px'
          },
          {
            text: this.$t('Net-Amount'),
            value: 'Net',
            align: 'right',
            visible: true,
            sortable: true,
            type: 'money',
            width: '150px'
          },
          {
            text: this.$t('VAT'),
            value: 'Kdv',
            align: 'right',
            visible: true,
            sortable: true,
            type: 'money',
            width: '150px'
          },
          {
            text: this.$t('Total'),
            value: 'Toplam',
            align: 'right',
            visible: true,
            sortable: true,
            type: 'money',
            width: '160px'
          },
          {
            text: this.$t('Currency-Total'),
            value: 'DovizToplam',
            align: 'right',
            visible: true,
            sortable: true,
            type: 'money',
            width: '170px'
          }
        ],
        gelirGen: {
          GelirBrut: 0,
          GelirDovizToplam: 0,
          GelirIskonto: 0,
          GelirKdv: 0,
          GelirNet: 0,
          GelirToplam: 0
        },

        giderGen: {
          GelirBrut: 0,
          GelirDovizToplam: 0,
          GelirIskonto: 0,
          GelirKdv: 0,
          GelirNet: 0,
          GelirToplam: 0
        },

        toplamGen: {
          GelirBrut: 0,
          GelirDovizToplam: 0,
          GelirIskonto: 0,
          GelirKdv: 0,
          GelirNet: 0,
          GelirToplam: 0
        },



        Rapor: {
          Cari: {
            Kod: null,
          },
          Evraklar: [],
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          Tip: '0', // 0 : Tümü, 1 : Alış , 2 : Satış
          Referanslar: [],
        },

        valid: true,
        tumsirketler: '',

        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],

        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi;
        // var params3 = {
        //   CompanyCode: credentials.SirketKodu
        // }

        // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
        //   headers: {
        //     'Authorization': 'Bearer ' + auth.getAuthHeader()
        //   }
        // }).then((response) => {
        //   this.referansitems = response.body
        // }, (response) => {
        //   if (response.status === 0) {
        //     this.text1 = 'Service Unavailable'
        //     this.snackbar = true
        //   } else {
        //     this.text1 = 'Service Unavailable'
        //     this.snackbar = true
        //   }
        // })




        this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.evraktipi = response.body

        }, (response) => {
          if (response.status === 0) {

          } else {

          }
        })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      yetkidialog,
      cariaracomp,
      ReportTable
    },

    computed: {
      ciroExportMetaItems() {
        var evraklar = Array.isArray(this.Rapor && this.Rapor.Evraklar)
          ? this.Rapor.Evraklar.map(function (x) {
              return x && x.Evrakkod ? x.Evrakkod : x
            }).join(', ')
          : ''

        return [
          { label: this.$t('Starting-Date'), value: this.Rapor ? this.Rapor.BaslangicTarih : '', type: 'date' },
          { label: this.$t('Finishing-Date'), value: this.Rapor ? this.Rapor.BitisTarih : '', type: 'date' },
          { label: this.$t('Currentcode_label'), value: this.Rapor && this.Rapor.Cari ? this.Rapor.Cari.Kod : '' },
          { label: this.$t('Document-Type'), value: evraklar },
          { label: this.$t('All-Companies'), value: this.tumsirketler === true ? this.$t('Yes') : this.$t('No') }
        ]
      },

      ciroGelirSummaryCards() {
        var cards = [
          {
            title: this.$t('Income'),
            items: [
              { label: this.$t('Gross'), value: this.gelirGen.GelirBrut, type: 'money' },
              { label: this.$t('Discount'), value: this.gelirGen.GelirIskonto, type: 'money' },
              { label: this.$t('Net'), value: this.gelirGen.GelirNet, type: 'money' },
              { label: this.$t('VAT'), value: this.gelirGen.GelirKdv, type: 'money' },
              { label: this.$t('Total'), value: this.gelirGen.GelirToplam, type: 'money' },
              { label: this.$t('Currency-Total'), value: this.gelirGen.GelirDovizToplam, type: 'money' }
            ]
          }
        ]

        if (this.Rapor && this.Rapor.Tip == '0') {
          cards.push({
            title: this.$t('Grand-Total'),
            items: [
              { label: this.$t('Gross'), value: this.toplamGen.GelirBrut, type: 'money' },
              { label: this.$t('Discount'), value: this.toplamGen.GelirIskonto, type: 'money' },
              { label: this.$t('Net'), value: this.toplamGen.GelirNet, type: 'money' },
              { label: this.$t('VAT'), value: this.toplamGen.GelirKdv, type: 'money' },
              { label: this.$t('Total'), value: this.toplamGen.GelirToplam, type: 'money' },
              { label: this.$t('Currency-Total'), value: this.toplamGen.GelirDovizToplam, type: 'money' }
            ]
          })
        }

        return cards
      },

      ciroGiderSummaryCards() {
        var cards = [
          {
            title: this.$t('Expense'),
            items: [
              { label: this.$t('Gross'), value: this.giderGen.GelirBrut, type: 'money' },
              { label: this.$t('Discount'), value: this.giderGen.GelirIskonto, type: 'money' },
              { label: this.$t('Net'), value: this.giderGen.GelirNet, type: 'money' },
              { label: this.$t('VAT'), value: this.giderGen.GelirKdv, type: 'money' },
              { label: this.$t('Total'), value: this.giderGen.GelirToplam, type: 'money' },
              { label: this.$t('Currency-Total'), value: this.giderGen.GelirDovizToplam, type: 'money' }
            ]
          }
        ]

        if (this.Rapor && this.Rapor.Tip == '0') {
          cards.push({
            title: this.$t('Grand-Total'),
            items: [
              { label: this.$t('Gross'), value: this.toplamGen.GelirBrut, type: 'money' },
              { label: this.$t('Discount'), value: this.toplamGen.GelirIskonto, type: 'money' },
              { label: this.$t('Net'), value: this.toplamGen.GelirNet, type: 'money' },
              { label: this.$t('VAT'), value: this.toplamGen.GelirKdv, type: 'money' },
              { label: this.$t('Total'), value: this.toplamGen.GelirToplam, type: 'money' },
              { label: this.$t('Currency-Total'), value: this.toplamGen.GelirDovizToplam, type: 'money' }
            ]
          })
        }

        return cards
      }
    },

    watch: {
      'Rapor.Tip': function (value) {

      }
    },
    methods: {
          getparabirimi() {
    return helpers.getparabirimi();
  },
  openMailDialog() {
    if (!this.mailPayload) this.mailPayload = {};
    this.mailPayload.DocType = this.$t('Turnover-Report');
    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
      this.$refs.mailForm.resetValidation();
    }
    this.mailDialog = true;
  },
  closeMailDialog() {
    this.mailDialog = false;
  },
  sendMail() {
    if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) return;
    if (!(this.$refs && this.$refs.formgunluksatis && this.$refs.formgunluksatis.validate && this.$refs.formgunluksatis.validate())) return;

    var credsRaw = window.localStorage.getItem('credentials');
    var creds = credsRaw ? JSON.parse(credsRaw) : {};
    var companyCode = this.tumsirketler === true ? '0' : (creds && creds.SirketKodu ? creds.SirketKodu : null);

    var R = JSON.parse(JSON.stringify(this.Rapor || {}));
    R.SirketKodu = companyCode;

    var refArr = [];
    if (this.ReferansPrm && this.ReferansPrm.Kod) refArr.push({ Kod: this.ReferansPrm.Kod });
    if (Array.isArray(R.Referanslar) && R.Referanslar.length > 0) {
      R.Referanslar.forEach(k => refArr.push(typeof k === "string" ? { Kod: k } : k));
    }
    R.Referanslar = refArr;

    var evrArr = [];
    if (Array.isArray(R.Evraklar)) {
      R.Evraklar.forEach(e => evrArr.push(typeof e === "string" ? { Evrakkod: e } : e));
    }
    R.Evraklar = evrArr;

    var mp = this.mailPayload || {};
    var payload = {
      Input: R,
      Mail: {
        To: mp.To || "",
        AgencyName: mp.AgencyName || "",
        DocType: mp.DocType || this.$t('Turnover-Report'),
        AgentFullName: mp.AgentFullName || "",
        CustomBody: mp.CustomBody || ""
      }
    };

    this.mailLoading = true;
    var endpoint = auth.API_URL + 'api/Report/MailGonderCiroRaporExcel';

    this.$http.post(endpoint, payload, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } })
      .then(() => {
        this.mailLoading = false;
        this.mailDialog = false;
        this.text1 = this.$t('Mail-Sent');
        this.snackbar = true;
      }, (err) => {
        this.mailLoading = false;
        var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
        var msg = (body && (body.Message || body.message)) || err.statusText || this.$t('Mail-Could-Not-Be-Sent');
        this.text1 = msg;
        this.snackbar = true;
      });
  },

      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable')
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = this.$t('Service-Unavailable')
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable')
        this.snackbar = true
      } else {
        this.text1 = this.$t('Service-Unavailable')
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable-Currency')
        this.snackbar = true
      } else {
        this.text1 = this.$t('Service-Unavailable-Currency')
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {

      } else {

      }
    })


  }




  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {

    this.filtrevarmi = false
    this.dialogfiltre = false
    this.Rapor.SirketKodu = null
    this.Rapor.Cari.Kod = null
    this.Rapor.Evraklar = []
    this.Rapor.Referanslar = []
    this.Rapor.Tip = '0'
    this.tumsirketler = ''

  }


  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false


      this.Rapor.Referanslar=[];
      if (this.ReferansPrm!=null && this.ReferansPrm.Kod!='')
      {
        this.Rapor.Referanslar.push(this.ReferansPrm);
      }




        var listevrak = [];

        this.Rapor.Evraklar.forEach(element => {
          var kayit = {
            Evrakkod: element
          }
          listevrak.push(kayit)
        });

        this.Rapor.Evraklar = listevrak


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Report/EndorsementReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.GelirDetay != null) {
            this.itemssatis = response.body.GelirDetay
          } else {
            this.itemssatis = []
          }



          this.gelirGen.GelirBrut = response.body.GelirBrut
          this.gelirGen.GelirDovizToplam = response.body.GelirDovizToplam
          this.gelirGen.GelirIskonto = response.body.GelirIskonto
          this.gelirGen.GelirKdv = response.body.GelirKdv
          this.gelirGen.GelirNet = response.body.GelirNet
          this.gelirGen.GelirToplam = response.body.GelirToplam


          if (this.itemsiade = response.body.GiderDetay != null) {
            this.itemsiade = response.body.GiderDetay
          } else {
            this.itemsiade = []
          }

          this.giderGen.GelirBrut = response.body.GiderBrut
          this.giderGen.GelirDovizToplam = response.body.GiderDovizToplam
          this.giderGen.GelirIskonto = response.body.GiderIskonto
          this.giderGen.GelirKdv = response.body.GiderKdv
          this.giderGen.GelirNet = response.body.GiderNet
          this.giderGen.GelirToplam = response.body.GiderToplam

          this.toplamGen.GelirBrut = response.body.GenelBrut
          this.toplamGen.GelirDovizToplam = response.body.GenelDovizToplam
          this.toplamGen.GelirIskonto = response.body.GenelIskonto
          this.toplamGen.GelirKdv = response.body.GenelKdv
          this.toplamGen.GelirNet = response.body.GenelNet
          this.toplamGen.GelirToplam = response.body.GenelToplam



          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
        this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var listreferans = [];

        this.Rapor.Referanslar.forEach(element => {
          var kayit = {
            Kod: element
          }
          listreferans.push(kayit)
        });

        this.Rapor.Referanslar = listreferans

        var listevrak = [];

        this.Rapor.Evraklar.forEach(element => {
          var kayit = {
            Evrakkod: element
          }
          listevrak.push(kayit)
        });

        this.Rapor.Evraklar = listevrak


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http
          .post(auth.API_URL + "api/Report/EndorsementReportHtml", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }).then((response) => {

            if (lang=='en')
          {

            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> CİRO RAPORU </title>','<title> TURNOVER REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>CİRO RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>TURNOVER REPORT</font>")
             bodyhtml=bodyhtml.toString().replace('GELİR :','INCOME :');
             bodyhtml=bodyhtml.toString().replace('GELÄ°R :','INCOME :');

             bodyhtml=bodyhtml.toString().replace('Kdv','Vat.');
             response.bodyText=bodyhtml;

          }
            this.progress = false
            this.load1 = true
            var blob = new Blob([response.bodyText], {
              type: 'application/html'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('CiroRaporu') + ".html";
            link.click();

            if (response.body.GelirDetay != null) {
              this.itemssatis = response.body.GelirDetay
            }
            this.gelirGen.GelirBrut = response.body.GelirBrut
            this.gelirGen.GelirDovizToplam = response.body.GelirDovizToplam
            this.gelirGen.GelirIskonto = response.body.GelirIskonto
            this.gelirGen.GelirKdv = response.body.GelirKdv
            this.gelirGen.GelirNet = response.body.GelirNet
            this.gelirGen.GelirToplam = response.body.GelirToplam


            if (this.itemsiade = response.body.GiderDetay != null) {
              this.itemsiade = response.body.GiderDetay
            }

            this.giderGen.GelirBrut = response.body.GiderBrut
            this.giderGen.GelirDovizToplam = response.body.GiderDovizToplam
            this.giderGen.GelirIskonto = response.body.GiderIskonto
            this.giderGen.GelirKdv = response.body.GiderKdv
            this.giderGen.GelirNet = response.body.GiderNet
            this.giderGen.GelirToplam = response.body.GiderToplam

            this.toplamGen.GelirBrut = response.body.GenelBrut
            this.toplamGen.GelirDovizToplam = response.body.GenelDovizToplam
            this.toplamGen.GelirIskonto = response.body.GenelIskonto
            this.toplamGen.GelirKdv = response.body.GenelKdv
            this.toplamGen.GelirNet = response.body.GenelNet
            this.toplamGen.GelirToplam = response.body.GenelToplam



            this.progress = false
            this.load1 = true

          }, (response) => {
            if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable')
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
        this.text1 = this.$t('Service-Unavailable')
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var listreferans = [];

        this.Rapor.Referanslar.forEach(element => {
          var kayit = {
            Kod: element
          }
          listreferans.push(kayit)
        });

        this.Rapor.Referanslar = listreferans

        var listevrak = [];

        this.Rapor.Evraklar.forEach(element => {
          var kayit = {
            Evrakkod: element
          }
          listevrak.push(kayit)
        });

        this.Rapor.Evraklar = listevrak


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http
          .post(auth.API_URL + "api/Report/EndorsementReportExcel", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }).then((response) => {
            this.progress = false
            this.load1 = true
            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('CiroRaporu') + ".xlsx";
            link.click();

            if (response.body.GelirDetay != null) {
              this.itemssatis = response.body.GelirDetay
            }
            this.gelirGen.GelirBrut = response.body.GelirBrut
            this.gelirGen.GelirDovizToplam = response.body.GelirDovizToplam
            this.gelirGen.GelirIskonto = response.body.GelirIskonto
            this.gelirGen.GelirKdv = response.body.GelirKdv
            this.gelirGen.GelirNet = response.body.GelirNet
            this.gelirGen.GelirToplam = response.body.GelirToplam


            if (this.itemsiade = response.body.GiderDetay != null) {
              this.itemsiade = response.body.GiderDetay
            }

            this.giderGen.GelirBrut = response.body.GiderBrut
            this.giderGen.GelirDovizToplam = response.body.GiderDovizToplam
            this.giderGen.GelirIskonto = response.body.GiderIskonto
            this.giderGen.GelirKdv = response.body.GiderKdv
            this.giderGen.GelirNet = response.body.GiderNet
            this.giderGen.GelirToplam = response.body.GiderToplam

            this.toplamGen.GelirBrut = response.body.GenelBrut
            this.toplamGen.GelirDovizToplam = response.body.GenelDovizToplam
            this.toplamGen.GelirIskonto = response.body.GenelIskonto
            this.toplamGen.GelirKdv = response.body.GenelKdv
            this.toplamGen.GelirNet = response.body.GenelNet
            this.toplamGen.GelirToplam = response.body.GenelToplam



            this.progress = false
            this.load1 = true

          }, (response) => {
            if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable')
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
        this.text1 = this.$t('Service-Unavailable')
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function beforeMount() {


  }
</script>
<style scoped>

/* Bu stiller yalnızca ciroraporu.vue sayfasına özeldir. */
.ciro-report-table {
  width: 100%;
  margin-top: 4px;
}

.ciro-report-table > * {
  width: 100%;
}

</style>
